import script from "./DataDisplayPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DataDisplayPage.vue?vue&type=script&setup=true&lang=js"

import "./DataDisplayPage.vue?vue&type=style&index=0&id=0d99ab80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d99ab80"]])

export default __exports__